<wuc-display-field *ngIf="premiumDeterminingFactor?.modifiableFactorFuture">
    <label>Toekomstig(e)
        {{ premiumDeterminingFactor?.modifiableFactorFuture?.factorDescription | lowercase }}</label>
    <span>
            {{ premiumDeterminingFactor?.modifiableFactorFuture?.factorValueDescription }}<br />
        <small>(per {{ premiumDeterminingFactor?.modifiableFactor?.endDate | dateFormat }})</small>
    </span>
    <wuc-link *ngIf="premiumDeterminingFactor?.modifiableCode === modifiableCodeEnum.Client"
              slot="action"
              type="secondary"
              iconRight="delete"
              iconSize="xs"
              (clicked)="onCancelAddedPremiumDeterminingFactor()">Annuleren</wuc-link>
</wuc-display-field>
